module.exports = {"token":"MOCK_TOKEN_PLACEHOLDER","user":{"id":111,"login":"john.doe@fake.mail","firstname":"John","lastname":"Doe","isAdmin":true}}


//////////////////
// WEBPACK FOOTER
// ./src/app/mock/userInfosMock.json
// module id = 570
// module chunks = 0